import React from 'react';
import './Card.css';

const Card = ({ 
  children, 
  title, 
  subtitle,
  headerAction,
  variant = 'default',
  padding = 'medium',
  hover = false,
  className = '',
  ...props 
}) => {
  const cardClass = `ui-card ui-card--${variant} ui-card--padding-${padding} ${hover ? 'ui-card--hover' : ''} ${className}`;
  
  return (
    <div className={cardClass} {...props}>
      {(title || subtitle || headerAction) && (
        <div className="ui-card__header">
          <div className="ui-card__header-content">
            {title && <h3 className="ui-card__title">{title}</h3>}
            {subtitle && <p className="ui-card__subtitle">{subtitle}</p>}
          </div>
          {headerAction && (
            <div className="ui-card__header-action">{headerAction}</div>
          )}
        </div>
      )}
      <div className="ui-card__body">{children}</div>
    </div>
  );
};

export default Card;
